import { render, staticRenderFns } from "./BackendJava.vue?vue&type=template&id=926b75d6&"
import script from "./BackendJava.vue?vue&type=script&lang=js&"
export * from "./BackendJava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports